<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{lang($store, 'sap/listings.not_found')}}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-row>
              <v-col
                v-for="(item, key) in paginatedObject.data"
                :key="'col_' + key"
                cols="12" lg="3"
                md="4" sm="6"
                class="py-1"
              >
                <v-card
                  class="pa-1"
                  :style="{
                  background: cardColor(item)
                  }"
                >
                  <div>
                    <div style="display: none">{{item.uuid}}</div>
                    <contact-line :contact="{name: item.name, phone: item.phone}"/>
                    <v-divider/>
                    <is-need-callback
                      :is-ok="item.is_need_callback"
                      :update-request="updateSimpleRequest(item, 'is_need_callback')"
                      @updated="item.is_need_callback = $event; $forceUpdate()"
                      :disabled="isForeman"
                    />
                    <datetime-alert
                      v-if="item.datetime"
                      :datetime="moment(item.datetime)"
                    />
                    <estimation-status
                      :value="item.estimation_status"
                      :update-request="updateSimpleRequest(item, 'estimation_status')"
                      @updated="item.estimation_status = $event; $forceUpdate()"
                      :disabled="isForeman"
                    />
                    <color-divider
                      :order-source="item.source"
                    />
                    <div class="d-flex flex-row">
                      <router-link
                        :to="{ name: 'estimations.complex.show', params: { estimationUuid: item.uuid }}">
                        <v-icon v-if="isForeman" small>mdi-file-document-outline</v-icon>
                        <v-icon v-else small>mdi-briefcase-edit-outline</v-icon>
                      </router-link>
                      <trash-button v-if="!isForeman" @click="onItemDelete(item)"/>
                      <comment-input
                        class="ml-2"
                        :value="item.minicomment"
                        :update-request="updateSimpleRequest(item, 'minicomment')"
                        @updated:text="item.minicomment = $event; $forceUpdate()"
                      />
                    </div>
                    <div>
                      <comment-input
                        class="w-100"
                        :value="item.minicomment2"
                        :update-request="updateSimpleRequest(item, 'minicomment2')"
                        @updated:text="item.minicomment2 = $event; $forceUpdate()"
                      />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* proxies */
import EstimationComplexProxy from '@/proxies/Estimations/EstimationComplexProxy';
/* constants */
import ColorDivider from '@/components/minialerts/ColorDivider.vue';
/* utils */
/* mixins */
import accountMixin from '@/mixins/accountMixin';
import orderUpdateSimpleProp from '@/mixins/orders/orderUpdateSimpleProp';
import isComponentLoading from '@/mixins/isComponentLoading';
/* components */
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import ContactLine from '@/components/minialerts/ContactLine.vue';
import TrashButton from '@/components/minialerts/TrashButton.vue';
import CommentInput from '@/components/minialerts/CommentInput.vue';
import EstimationStatus from '@/components/minialerts/EstimationStatus.vue';
import IsNeedCallback from '@/components/minialerts/IsNeedCallback.vue';
import { roles as rolesColors } from '../../utils/listingColors';
import {
  ESTIMATING,
  NOT_SUITABLE,
  ORDERED,
  WAITING_PHOTO,
  ESTIMATED,
  DONE,
  DECLINED,
} from '../../constants/estimation_statuses';


export default {
  name: 'TablePaginatedEstimationsComplex',
  components: {
    DatetimeAlert,
    ContactLine,
    TrashButton,
    CommentInput,
    EstimationStatus,
    ColorDivider,
    IsNeedCallback,
  },
  mixins: [isComponentLoading, orderUpdateSimpleProp, accountMixin],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      rolesColors,
      ORDERED,
      L: _,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    cardColor(item) {
      switch (item.estimation_status) {
        case ORDERED:
          return '#f1f2f6';
        case WAITING_PHOTO:
          return '#ffffff';
        case ESTIMATING:
          return '#fffa65';
        case ESTIMATED:
          return '#ffaf40';
        case NOT_SUITABLE:
          return '#ff4d4d';
        case DONE:
          return '#32ff7e';
        case DECLINED:
          return '#7f8c8d';
        default:
          return 'red';
      }
    },
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onItemCopy(item) {
      this.$emit('copy-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    onAddressEdit(item, address) {
      this.$emit('edit-address', {
        item,
        address,
      });
    },
    onAddressDelete(item, address) {
      this.$emit('delete-address', {
        item,
        address,
      });
    },
    getUpdateSimpleRequestClient() {
      return new EstimationComplexProxy();
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-action
    &:hover
      fill: #0066ff
      transition: fill 0.5s
      cursor: pointer
</style>
